import { TermDto } from '@act/shared/data-transfer-objects';
import { consentAppSelectors } from 'redux/slices/consent.slice';
import { GenericDialogProps } from 'utilities/dialog-context/dialog-context-helpers';
import ConsentIdentityForm from 'react-components/consents/guide-view/consent-identity';
import ConsentTermForm from 'react-components/consents/guide-view/ConsentTermForm';

export interface TermConsentsDialogUniqueProps {
  term: TermDto;
}

export type TermConsentsDialogCallbackInput = void;

export type TermConsentsDialogProps =
  GenericDialogProps<TermConsentsDialogCallbackInput> &
    TermConsentsDialogUniqueProps;

export const TermConsentsDialog = ({
  term,
  open,
  setOpen,
  callback,
}: TermConsentsDialogProps) => {
  const termIdentityId = consentAppSelectors.useSelectTermIdentityId();
  const requiresIdentity = !!term?.identityRequired;
  const handleClose = () => {
    setOpen(false);
    callback();
  };
  return !!requiresIdentity && !termIdentityId ? (
    <ConsentIdentityForm open={open} handleClose={handleClose} />
  ) : (
    <ConsentTermForm term={term} open={open} handleClose={handleClose} />
  );
};
